import React, { Component } from 'react'

import { Modal } from 'react-bootstrap'
import PermissionsChecker from '@shared/PermissionsChecker'
import { formatMoney } from '@shared/FormatMoney'
import _ from 'lodash'
import Tag from '../../shared/Tag'
import { connect } from 'react-redux'
import { showToastNotification } from '../../actions/toastNotification'

class ProductsTable extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showCancelItemModal: false,
      selectedItemToCancel: {},
      itemIdToCancel: null,
    }

    this.handleCancelItem = this.handleCancelItem.bind(this)
  }

  handleCancelItem() {
    this.setState(
      {
        showCancelItemModal: false,
      },
      () =>
        this.props.handleCancelOrderItem(this.state.itemIdToCancel).then(() => {
          this.setState({
            itemIdToCancel: null,
          });
          this.props.showToastNotification({
            title: 'Cancelado com sucesso!',
            text: 'O item foi cancelado e o valor final foi atualizado.',
            variant: 'success'
          })
        },
      ),
    )
  }

  productsListTable(productList, hideActions = false) {
    const {header} = this.props;

    return (
      <table cellSpacing="0" cellPadding="0" className="books-table__table">
        <thead className="books-table__header">
          <tr className="books-table__header-row">
            {header.map((column, index) => (
              <th className="books-table__col" key={index}>
                {column.alias}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="books-table__body">
          {productList.map((item, index) => (
            <tr className="books-table__row" key={index}>
              {header.map((column, index) => (
                <td
                  className={`books-table__cell ${
                    column.property !== 'cancelled_at' && !_.isEmpty(item.cancelled_at) ? 'cancelled' : ''
                  }`}
                  key={index}
                >
                  {column.property === 'cancelled_at' && !hideActions ? (
                    <React.Fragment>
                      {!_.isEmpty(item[column.property]) ? (
                        <span className={`column column__${column.property}`}>
                          <Tag variant="warning" text="Cancelado" />
                        </span>
                      ) : (
                        <>
                          {/* Visão Administrador */}
                          <PermissionsChecker permissions={['cancel_order_item']}>
                            <button
                              className="button button__cancel"
                              onClick={() => {
                                this.setState({
                                  selectedItemToCancel: item,
                                  showCancelItemModal: true,
                                  itemIdToCancel: item.id,
                                })
                              }}
                            >
                              Cancelar item
                            </button>
                          </PermissionsChecker>
                          {/* Visão Comprador */}
                          <PermissionsChecker permissions={['cancel_order_item']} negate={true}>
                            <Tag variant="info" text="Incluído" />
                          </PermissionsChecker>
                        </>
                      )}
                    </React.Fragment>
                  ) : (
                    {
                      image: (
                        <img src={item[column.property]} alt="" className={`column column__${column.property}`} />
                      ),
                      currency: (
                        <div className={`column column__${column.property}`}>
                          {formatMoney(item[column.property], 2, 2)}
                        </div>
                      ),
                      default: <span className={`column column__${column.property}`}>{item[column.property]}</span>,
                      name: (
                        <div>
                          <span className={`column column__${column.property}`}>{item[column.property]}</span>
                          {item.bookLicenses && Object.entries(item.bookLicenses).map(([key, license_code]) => (
                            <span key={license_code.license_code} className={`column column__license_code`}>
                              <b>{license_code.component || 'Chave da licença'}: </b>
                              {license_code.license_code}
                            </span>
                          ))}
                        </div>
                      ),
                    }[column.type]
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  render() {
    const { products, header, fixedCol, orderId } = this.props
    const list = products.map(product => {
      let itens = header.reduce((prev, item, index, arr) => {
        let temp = {}
        if (fixedCol[item.property]) {
          temp[item.property] = fixedCol[item.property]
        } else if (item.key) {
          temp[item.property] = product[item.property][item.key]
        } else {
          temp[item.property] = product[item.property]
        }
        temp.id = product.id
        temp.bookLicenses = product.bookLicenses
        return { ...prev, ...temp }
      }, {})
      return { ...itens }
    })

    return (
      <div className="books-table">
        <Modal show={this.state.showCancelItemModal}>
          <Modal.Body>
            <div className="modalHeader">
              {/* <span className="icon-alert" /> */}
              <i class="fa fa-check-circle" aria-hidden="true"></i>
              <h5>Deseja realmente cancelar o item do pedido SMD-{orderId}?</h5>
              <h6>Não é possível desfazer essa ação.</h6>
            </div>

            <div className="modalContent modal-products-list">
              {this.productsListTable([this?.state?.selectedItemToCancel], true)}
            </div>

            <div className="actions-area">
              <button 
                className="button button__normal"
                onClick={() =>
                  this.setState({
                    showCancelItemModal: false,
                    itemIdToCancel: null,
                  }, () => {
                    this.setState({ selectedItemToCancel: {} });
                  })
                }
              >
                Fechar
              </button>

              <button
                className="button button__cancel"
                onClick={this.handleCancelItem}
              >
                Sim, cancelar item
              </button>
            </div>
          </Modal.Body>
        </Modal>
        {this.productsListTable(list)}
      </div>
    )
  }
}

const mapStateProps = state => ({
})

const mapDispatchToProps = dispatch => ({
  showToastNotification: (data) => dispatch(showToastNotification(data)),
})

export default connect(mapStateProps, mapDispatchToProps)(ProductsTable)

